module.exports = __webpack_public_path__ + "static/road-with-trees-5b3b68ed3fdb596337e71fe682785d37.jpg";